var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cleave',_vm._g(_vm._b({staticClass:"cbs-masked-input",attrs:{"value":_vm.value,"options":_vm.options},on:{"input":function (val) { return _vm.$emit('input', val); }}},'cleave',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }